import { render, staticRenderFns } from "./DonutChart84.vue?vue&type=template&id=1b205050&scoped=true"
import script from "./DonutChart84.vue?vue&type=script&lang=js"
export * from "./DonutChart84.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b205050",
  null
  
)

export default component.exports